import React from 'react'
import { Row } from 'react-bootstrap'

import styles from './styles.module.sass'
import mainContent from './mainContent-min.png'

export default props => {
  return (
    <Row>
      <div className={styles.container}>
        <img src={mainContent} className={styles.container__image} alt="" />
        <div
          onClick={() => props.history.push('/services')}
          className={styles.container__service__img}></div>
        <div
          onClick={() => props.history.push('/services')}
          className={styles.container__service}>
          Наши услуги
        </div>
        <div
          onClick={() => props.history.push('/projects')}
          className={styles.container__projects__img}></div>
        <div
          onClick={() => props.history.push('/projects')}
          className={styles.container__projects}>
          Проекты
        </div>
        <div
          onClick={() => props.history.push('/technologies')}
          className={styles.container__tech__img}></div>
        <div
          onClick={() => props.history.push('/technologies')}
          className={styles.container__tech}>
          Технология работы
        </div>
        <div
          onClick={() => props.history.push('/designers')}
          className={styles.container__designers__img}></div>
        <div
          onClick={() => props.history.push('/designers')}
          className={styles.container__designers}>
          Дизайн студии
        </div>
        <div
          onClick={() => props.history.push('/tours')}
          className={styles.container__tours__img}></div>
        <div
          onClick={() => props.history.push('/tours')}
          className={styles.container__tours}>
          Спец Предложения
        </div>
        <div
          onClick={() => props.history.push('/about')}
          className={styles.container__about__img}></div>
        <div
          onClick={() => props.history.push('/about')}
          className={styles.container__about}>
          О нас
        </div>
      </div>
    </Row>
  )
}

//
//
//
//
//
